import httpClient from './httpClient';

/**
 * Serviço utilitário para consumir as APIs de telefones do backend.
 */
export async function listarTelefonesPorContato(contatoId) {
  const resp = await httpClient.get(`/api/telefones/por-contato/${contatoId}`);
  return resp.data;
}

export async function salvarTelefone(telefone) {
  const resp = await httpClient.post('/api/telefones', telefone);
  return resp.data;
}

export async function atualizarTelefone(id, telefone) {
  const resp = await httpClient.put(`/api/telefones/${id}`, telefone);
  return resp.data;
}

export async function removerTelefone(id) {
  await httpClient.delete(`/api/telefones/${id}`);
}
